import { Modal } from 'antd';
import styles from './index.module.sass';
import { useStore } from 'effector-react';
import {
  $myWarehouses,
  clearCalculatorActiveWarehouseData,
  clearWrehouseData,
  fetchMyWarehouses,
  fetchWarehouseData,
  fetchWarehouseForCalculatorById,
} from '@/widgets/recipe/model';
import { useEffect, useRef, useState } from 'react';
import { WarehouseItem } from './components/warehouse-item';
import { ICalculatorBag } from '../../ts/rustmix-buyer.types';
import { ButtonPrimary } from '@/shared/ui/button';
import type { DraggableData, DraggableEvent } from 'react-draggable';
import Draggable from 'react-draggable';

export const CalculatorSelectSourceModal = ({
  setVisible,
  visible,
  componentNumber,
  setBagA,
  setBagB,
  recalculateFoo,
  selectedBags,
  setSelectedBags,
}: IArgs) => {
  const myWarehouses: any = useStore($myWarehouses);

  useEffect(() => {
    fetchMyWarehouses();
  }, []);

  const [activeWh, setActiveWh] = useState(-1);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    pages_count: null,
  });
  const [disabled, setDisabled] = useState(true);
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 });
  const draggleRef = useRef<HTMLDivElement>(null);

  const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();
    if (!targetRect) {
      return;
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
  };

  useEffect(() => {
    if (activeWh !== -1) {
      clearCalculatorActiveWarehouseData();
      fetchWarehouseForCalculatorById({
        id: activeWh,
        //limit: pagination.limit,
        //page: pagination.page,
      });
    }
  }, [activeWh]);
  return (
    <Modal
      onCancel={() => setVisible(0)}
      className={styles.root}
      title={
        <div
          style={{
            width: '100%',
            cursor: 'move',
          }}
          onMouseOver={() => {
            if (disabled) {
              setDisabled(false);
            }
          }}
          onMouseOut={() => {
            setDisabled(true);
          }}
        >
          {`выбор источника ${componentNumber} компонента`}
        </div>
      }
      open={visible > 0}
      width={1050}
      footer={
        <>
          <ButtonPrimary
            className={styles.okayButton}
            label="применить"
            onClick={() => {
              recalculateFoo();
              setVisible(0);
            }}
          />
        </>
      }
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={bounds}
          nodeRef={draggleRef}
          onStart={(event, uiData) => onStart(event, uiData)}
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
    >
      {myWarehouses &&
        Array.isArray(myWarehouses) &&
        myWarehouses.map((item, i) => (
          <WarehouseItem
            key={i}
            title={item.name}
            type={+item.type as 1 | 2}
            count={+item.filled_bags}
            id={+item.id}
            idx={i + 1}
            description=""
            activeWh={activeWh}
            setActiveWh={setActiveWh}
            setBagFoo={
              componentNumber === 1
                ? setBagA
                : componentNumber === 2
                ? setBagB
                : undefined
            }
            setBagDefStateFoo={(val: any) => {
              if (componentNumber === 1) {
                localStorage.setItem('bag_a_initial_state', JSON.stringify(val));
              } else if (componentNumber === 2) {
                localStorage.setItem('bag_b_initial_state', JSON.stringify(val));
              }
            }}
            setPagination={setPagination}
            hideModalFoo={() => {
              recalculateFoo();
              setVisible(0);
            }}
            selectedBags={selectedBags}
            setSelectedBags={setSelectedBags as any}
            componentNumber={componentNumber}
            pagination={pagination}
          />
        ))}
    </Modal>
  );
};

interface IArgs {
  setVisible: (val: number) => void;
  visible: number;
  componentNumber: 1 | 2;
  setBagA: (val: ICalculatorBag) => void;
  setBagB: (val: ICalculatorBag) => void;
  recalculateFoo: () => void;
  selectedBags: [string, string];
  setSelectedBags: (val: [string, string]) => void;
}
